import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_004.jpg';

page.games = [
  {
    id: 'page004_game1',
    icon: 'ikonaCwiczenie',
    color: '#FF808080',
    tooltip: 's. 4',
    pos: {
      x: LEFT,
      y: 40,
    },
    item: {
      id: 'page004_game1',
    },
  },
];

export default page;
